import { createAction, createAsyncThunk } from '@reduxjs/toolkit';
import ProfessionalController from '../controllers/ProfessionalController';
import { statusDispatch } from './globalActions';
import {
  IGenerateInvoiceParams,
  IMarkAsPaidParams,
  IProfessionalInvoiceParams,
  IRatePharmacyParams,
} from '../models';

export const professionalActions = {
  rate: 'professional/rate',
  rating: 'professional/rating',
  ratingItems: 'professional/ratingitems',
  resetProfessionalValue: 'professional/reset',
  bookedRating: 'professional/bookedRating',
  getProfessionalInvoice: 'professional/get/invoice',
  generateProfessionalInvoice: 'professional/generate/invoice',
  markAsPaid: 'professional/mark-paid',
};

export const getPharmacyRating = createAsyncThunk(
  professionalActions.rating,
  async (pharmacyId: string, { rejectWithValue }) => {
    try {
      const resp = await ProfessionalController.rating(pharmacyId);
      return statusDispatch(resp, rejectWithValue);
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const getPharmacyBookedRating = createAsyncThunk(
  professionalActions.bookedRating,
  async (bookingId: string, { rejectWithValue }) => {
    try {
      const resp = await ProfessionalController.getBookedRating(bookingId);
      return statusDispatch(resp, rejectWithValue);
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const ratePharmacy = createAsyncThunk(
  professionalActions.rate,
  async (params: IRatePharmacyParams, { rejectWithValue }) => {
    try {
      const resp = await ProfessionalController.rate(params);
      return statusDispatch(resp, rejectWithValue);
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const getPharmacyRatingItems = createAsyncThunk(
  professionalActions.ratingItems,
  async (pharmacyId: string, { rejectWithValue }) => {
    try {
      const resp = await ProfessionalController.ratingItems(pharmacyId);
      return statusDispatch(resp, rejectWithValue);
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const getProfessionalInvoice = createAsyncThunk(
  professionalActions.getProfessionalInvoice,
  async (params: IProfessionalInvoiceParams, { rejectWithValue }) => {
    try {
      const resp = await ProfessionalController.getProfessionalInvoice(params);
      return statusDispatch(resp, rejectWithValue);
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const generateProfessionalInvoice = createAsyncThunk(
  professionalActions.generateProfessionalInvoice,
  async (params: IGenerateInvoiceParams, { rejectWithValue }) => {
    try {
      const resp = await ProfessionalController.generateProfessionalInvoice(
        params
      );
      return statusDispatch(resp, rejectWithValue);
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const markAsPaid = createAsyncThunk(
  professionalActions.markAsPaid,
  async (params: IMarkAsPaidParams, { rejectWithValue }) => {
    try {
      const resp = await ProfessionalController.markAsPaid(params);
      return statusDispatch(resp, rejectWithValue);
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const resetProfessionalValue = createAction<Array<string>>(
  professionalActions.resetProfessionalValue
);
